import React from 'react'

class DisclaimerDe extends React.Component {
  render() {
    return <div>
      <h2>Wichtige Mitteilungen</h2>

      <h3>Haftungsverzichtserklärung</h3>

      <p>Die Texte und Erläuterungen auf SenLex-Internetseite werden kostenlos zur Information der Öffentlichkeit zur Verfügung gestellt.</p>

      <p>Der Benutzer darf die gelieferten Informationen nicht als Rechtsberatung auffassen.</p>

      <p>Aus der Angabe oder Nichtangabe eines parlamentarischen Dokumentes, eines Beschlusses, eines Gutachtens oder eines gleich welchen anderen Textes oder Teil eines Textes kann kein Werturteil über den Bilder der Datenbank abgeleitet werden.</p>

      <p>Alle Daten auf dieser Site gelten als korrekt zum Zeitpunkte ihrer Veröffentlichung, wobei keinerlei diesbezügliche Garantie gegeben werden kann. Anders ausgedrückt erfolgt die Verwendung dieser Informationen auf eigene Risiken und Gefahren. Der Inhalt der Site kann jederzeit ohne Vorankündigung oder Bekanntmachung angepasst, geändert oder vervollständigt werden.</p>

      <p>Der Senat kann auf keinen Fall von irgendwem weder direkt noch indirekt auf besondere oder sonstige Art und Weise für Schäden haftbar gemacht werden, die auf die Benutzung der Site oder einer Site, auf die ein (Hyper)link verweist, zurückzuführen sind, einschließlich und ohne Einschränkung sämtlicher Verluste, Arbeitsausfälle, Beschädigungen von Programmen oder sonstigen Daten im Rechnersystem, von Gerätschaften, Programmierungen oder von sonstigem Hab und Gut des Benutzers.</p>

      <p>Die SenLex-Datenbank verbessert die Ihrerseits angegebenen Informationslücken, erteilt aber keine Antwort auf einzelne Fragen und gewährt keinen Rechtsbeistand bezüglich der Identifizierung, der Interpretation oder der Anwendung der zur Verfügung gestellten Informationen.</p>
    </div>
  }
}



export default DisclaimerDe;



/** WEBPACK FOOTER **
 ** ./src/modules/helptexts/disclaimer/de.js
 **/